import { createSlice } from "@reduxjs/toolkit";

const initialQueueFaspayState = {
  listLoading: false,
  actionsLoading: false,
  entities: null,
  meta: { total: 0 },
  links: null,
  error: null,
  queueFaspayForView: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const queueFaspaySlice = createSlice({
  name: "queueFaspay",
  initialState: initialQueueFaspayState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    queueFaspayFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    getQueueFaspay: (state, action) => {
      state.actionsLoading = false;
      state.queueFaspayForView = action.payload.queueFaspayForView;
      state.error = null;
    },
    queueFaspayExecuted: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // ponytail: Filter out the executed queue from current list entities if loaded.
      if (state.entities) {
        state.entities = state.entities.filter(
          (el) => el.id !== action.payload.id
        );
      }
    },
  },
});
